var map = {
	"./choosing-registration-system.md": 1786,
	"./complete-guide-sports-software.md": 1787,
	"./dance-studio-software.md": 1788,
	"./gymnastics-class-software-guide.md": 1789,
	"./ice-skating-program-management.md": 1790,
	"./managing-seasonal-registrations.md": 1791,
	"./martial-arts-school-management.md": 1792,
	"./online-registration-benefits.md": 1793,
	"./parent-communication-best-practices.md": 1794,
	"./scaling-sports-program.md": 1795,
	"./signs-program-needs-software.md": 1796,
	"./skill-tracking-youth-sports.md": 1797,
	"./sports-software-roi.md": 1798,
	"./swimming-lesson-management.md": 1799
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1785;